import { render } from "./App.vue?vue&type=template&id=0f0d4547"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0f0d4547&lang=css"

import exportComponent from "D:\\work\\六合合集\\6hhjm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__